var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C6.79372 0 6.59589 0.0772796 6.45003 0.214838C6.30417 0.352397 6.22222 0.538966 6.22222 0.733503V2.20051H1.55556C1.143 2.20051 0.747335 2.35507 0.455612 2.63019C0.163888 2.9053 0 3.27844 0 3.66752V13.2031C0 13.5921 0.163888 13.9653 0.455612 14.2404C0.747335 14.5155 1.143 14.6701 1.55556 14.6701H12.4444C12.857 14.6701 13.2527 14.5155 13.5444 14.2404C13.8361 13.9653 14 13.5921 14 13.2031V3.66752C14 3.27844 13.8361 2.9053 13.5444 2.63019C13.2527 2.35507 12.857 2.20051 12.4444 2.20051H7.77778V0.733503C7.77778 0.538966 7.69583 0.352397 7.54997 0.214838C7.40411 0.0772796 7.20628 0 7 0ZM7.77778 2.20051V8.67588L9.19956 7.33503C9.3454 7.1974 9.54324 7.12004 9.74956 7.11997C9.95588 7.1199 10.1538 7.19713 10.2997 7.33467C10.4457 7.47221 10.5277 7.65879 10.5278 7.85336C10.5278 8.04794 10.446 8.23457 10.3001 8.37221L7.68678 10.836C7.50448 11.0078 7.25731 11.1043 6.99961 11.1043C6.74191 11.1043 6.49475 11.0078 6.31244 10.836L3.69989 8.37221C3.62768 8.30406 3.5704 8.22316 3.53134 8.13414C3.49228 8.04511 3.4722 7.94971 3.47223 7.85336C3.47227 7.75702 3.49243 7.66162 3.53155 7.57263C3.57068 7.48363 3.62801 7.40277 3.70028 7.33467C3.77254 7.26657 3.85832 7.21255 3.95272 7.17572C4.04711 7.13888 4.14828 7.11994 4.25044 7.11997C4.3526 7.12 4.45375 7.13901 4.54812 7.17591C4.64249 7.21282 4.72823 7.26688 4.80044 7.33503L6.22222 8.67588V2.20051H7.77778Z",
    fill: "url(#paint0_linear_9223_8934)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9223_8934",
    x1: 0,
    y1: 7.33503,
    x2: 14,
    y2: 7.33503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52FAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197AD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTracking);
export default __webpack_public_path__ + "static/media/download-tracking.ffa91212ef5a1f4a670a2d14d1e26f69.svg";
export { ForwardRef as ReactComponent };